var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGpsMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.12,
    y: 322.65,
    width: 68.79,
    height: 130.55,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.66,
    y: 322.65,
    width: 32.25,
    height: 130.55,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.55,
    y: 334.93,
    width: 6.18,
    height: 15.03,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.55,
    y: 393.74,
    width: 6.18,
    height: 15.03,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.66,355.86c0,.13-8.18.23-18.27.23s-18.27-.1-18.27-.23,8.18-.24,18.27-.24S131.66,355.73,131.66,355.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.55,
    y: 364.56,
    width: 6.18,
    height: 15.03,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.66,385.49c0,.12-8.18.23-18.27.23s-18.27-.11-18.27-.23,8.18-.24,18.27-.24S131.66,385.36,131.66,385.49Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.51,
    y: 334.93,
    width: 6.18,
    height: 15.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.93,
    y: 334.93,
    width: 6.18,
    height: 15.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.51,
    y: 363.45,
    width: 6.18,
    height: 15.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.93,
    y: 363.45,
    width: 6.18,
    height: 15.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.51,
    y: 391.96,
    width: 6.18,
    height: 15.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.93,
    y: 391.96,
    width: 6.18,
    height: 15.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.95,
    y: 319.49,
    width: 79.13,
    height: 3.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.39,323.07c0,.13-15.37.23-34.33.23s-34.34-.1-34.34-.23,15.37-.23,34.34-.23S164.39,322.94,164.39,323.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.92,
    y: 371.61,
    width: 61.58,
    height: 81.22,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.63,
    y: 371.61,
    width: 28.87,
    height: 81.22,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.83,
    y: 382.61,
    width: 5.54,
    height: 13.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.83,
    y: 435.26,
    width: 5.54,
    height: 13.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.63,401.34c0,.15-7.33.27-16.36.27s-16.35-.12-16.35-.27,7.32-.28,16.35-.28S82.63,401.19,82.63,401.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.83,
    y: 409.13,
    width: 5.54,
    height: 13.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.63,427.86c0,.15-7.33.28-16.36.28s-16.35-.13-16.35-.28,7.32-.27,16.35-.27S82.63,427.71,82.63,427.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.76,
    y: 382.61,
    width: 5.54,
    height: 13.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.77,
    y: 382.61,
    width: 5.54,
    height: 13.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.76,
    y: 408.13,
    width: 5.54,
    height: 13.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.77,
    y: 408.13,
    width: 5.54,
    height: 13.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.76,
    y: 433.66,
    width: 5.54,
    height: 13.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.77,
    y: 433.66,
    width: 5.54,
    height: 13.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.29,
    y: 368.78,
    width: 70.84,
    height: 2.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.93,372c0,.15-13.76.27-30.74.27s-30.74-.12-30.74-.27,13.76-.28,30.74-.28S111.93,371.84,111.93,372Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.47,66.27s-9.8,3-.76,24,15.58,31.63,15.58,31.63,1.53,4.85-2.5,5.32-12.71-1.51-14.8,3.25c-2.18,4.93,1.18,9.94,8.34,14.61s22.48,15.49,23.87,16.47,2.63,3.27-.07,4S89.58,167.1,90.5,176.5s23,19.14,25.42,20.25,2.91,2.19,2.62,3.53-7,1-12.62,1.4S93.82,203.63,94.8,209s13.67,17.38,46,22.73l15.16,1.5L165.1,221c17.9-27.48,17.61-44.93,14.31-49.29s-8.77-.62-12.91,3.24-8.38,9.05-9.56,8.37-1.63-1.81-.83-4.32,8.53-25.4,2.22-32.42-20.27,7.1-22.65,8.58-3.21-1-3-2.67,2.58-20.29,4-28.73,0-14.29-5.14-16c-4.93-1.67-9.33,6.07-12.39,8.72s-5.62-1.75-5.62-1.75-3.38-12-12.8-32.84S82.27,66.34,82.27,66.34",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.53,236.87c-6.86-15.37-18.6-42.9-28.8-66.48s-19.44-44.9-26.23-60.31l-8-18.23c-.94-2.14-1.68-3.81-2.18-5l-.56-1.3-.18-.45a3.6,3.6,0,0,1,.22.43c.15.31.35.73.6,1.28l2.27,4.92c2,4.28,4.76,10.49,8.19,18.18,6.86,15.37,16.16,36.68,26.36,60.25s21.88,51.13,28.67,66.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,133.73a4.82,4.82,0,0,1,1,.37c.66.26,1.6.66,2.76,1.17,2.31,1,5.47,2.53,8.92,4.25l8.83,4.43,2.69,1.32a4.48,4.48,0,0,1,1,.53,5.06,5.06,0,0,1-1-.36c-.66-.26-1.6-.67-2.75-1.19-2.3-1.05-5.44-2.59-8.9-4.31l-8.86-4.36L93,134.27A5.14,5.14,0,0,1,92,133.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.32,144.9c-.12-.06,2.68-6.7,6.26-14.85s6.58-14.71,6.7-14.66-2.69,6.7-6.27,14.85S118.44,145,118.32,144.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.34,181.81a5.71,5.71,0,0,1,.68-.9l2-2.34c1.66-2,3.93-4.73,6.33-7.85s4.48-6,6-8.11l1.76-2.5a6.34,6.34,0,0,1,.69-.89,4.51,4.51,0,0,1-.54,1c-.37.62-.93,1.51-1.64,2.59-1.42,2.15-3.46,5.09-5.87,8.21s-4.72,5.85-6.44,7.78c-.87,1-1.58,1.73-2.08,2.24A5,5,0,0,1,132.34,181.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.33,177a4,4,0,0,1,1,.08l2.8.41c2.36.37,5.61.91,9.19,1.53s6.83,1.21,9.18,1.66l2.77.56a3.67,3.67,0,0,1,1,.27,4.48,4.48,0,0,1-1-.09l-2.79-.41c-2.36-.36-5.61-.9-9.2-1.53s-6.83-1.21-9.17-1.66l-2.77-.56A4.59,4.59,0,0,1,106.33,177Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,211.1a7.93,7.93,0,0,1,1.32.13l3.59.51c3,.45,7.2,1.11,11.8,1.86s8.77,1.47,11.78,2l3.56.66a7.19,7.19,0,0,1,1.29.31,8,8,0,0,1-1.32-.13l-3.59-.51c-3-.45-7.19-1.11-11.8-1.86s-8.76-1.46-11.78-2l-3.56-.66A6.24,6.24,0,0,1,114.57,211.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.15,216.21a9.89,9.89,0,0,1,.84-1.16l2.38-3.06c2-2.58,4.76-6.16,7.7-10.2s5.5-7.76,7.34-10.47c.89-1.3,1.62-2.38,2.18-3.21a9.19,9.19,0,0,1,.85-1.15,9.23,9.23,0,0,1-.69,1.25c-.47.79-1.17,1.91-2.06,3.29-1.77,2.76-4.29,6.52-7.24,10.57s-5.75,7.6-7.82,10.13c-1,1.27-1.9,2.28-2.5,3A8.1,8.1,0,0,1,147.15,216.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.8,275.76c-20.26-14.15-24.85-40.42-24.05-64,.13-3.94-.3-8.1,1.57-11.56s6.25-5.82,9.78-4.16c2.93,1.38,4.21,4.79,5.84,7.6a23,23,0,0,0,9.25,8.83c2.51,1.3,5.61,2.1,8.09.73,3.4-1.87,3.8-6.57,3.78-10.49q-.07-11-.14-21.92c0-3.92,0-7.92,1.18-11.64s3.92-7.18,7.65-8.22,8.34,1.1,9.12,4.94c.33,1.6,0,3.25.12,4.88s.86,3.43,2.41,3.88,3.13-.65,4.3-1.8c4.05-4,6.8-9.05,9.36-14.13s5.06-10.26,8.73-14.58,8.75-7.73,14.36-8.05,11.6,3.15,13,8.66-1.8,11.13-5.31,15.61a87.7,87.7,0,0,1-18.22,17.36c-1.24.88-2.58,1.83-3.05,3.28-.85,2.61,1.63,5.21,4.21,6.07,2.92,1,6.09.67,9.15,1s6.36,1.71,7.52,4.59c1.61,4-1.74,8.21-5,11a74.93,74.93,0,0,1-22.19,12.81c-2.88,1.05-5.92,2-8.24,4s-3.73,5.55-2.33,8.31,5,3.64,8,3.08,5.72-2.2,8.6-3.28c5.39-2,12.34-1.66,15.8,3,2.26,3.06,2.46,7.32,1.32,11s-3.48,6.79-5.95,9.69c-8.63,10.13-19.69,18.29-32.18,22.62s-24.08,5.51-36.5,1",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.49,293.27A172.51,172.51,0,0,1,380.9,261a349,349,0,0,1,13.94-37.82c1.41-3.28,2.79-6.53,4.16-9.72s2.74-6.36,4.26-9.37a177.92,177.92,0,0,1,9.75-16.8c3.36-5.19,6.74-10,9.93-14.47s6.26-8.57,9.21-12.19a140.48,140.48,0,0,1,15.18-16.05c1.93-1.74,3.48-3,4.54-3.92l1.21-1a2.51,2.51,0,0,1,.43-.32,3,3,0,0,1-.38.37l-1.17,1c-1,.91-2.54,2.25-4.44,4a149,149,0,0,0-15,16.17c-2.91,3.63-5.94,7.74-9.12,12.22s-6.52,9.29-9.85,14.48a177.29,177.29,0,0,0-9.68,16.76c-1.51,3-2.85,6.13-4.23,9.33s-2.75,6.44-4.16,9.72a359.36,359.36,0,0,0-14,37.72A174.72,174.72,0,0,0,375,293.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.47,204a8.14,8.14,0,0,1-.38-1.68c-.21-1.08-.45-2.66-.73-4.61-.55-3.9-1.14-9.32-1.75-15.29s-1.28-11.37-1.89-15.26c-.3-1.94-.56-3.51-.75-4.59a7.59,7.59,0,0,1-.22-1.7,8.16,8.16,0,0,1,.49,1.64c.28,1.07.61,2.63,1,4.57.74,3.87,1.48,9.28,2.1,15.26s1.13,11.23,1.55,15.31c.19,1.84.36,3.39.49,4.63A7.66,7.66,0,0,1,403.47,204Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.87,194.61a11.13,11.13,0,0,1-2,.24c-1.29.11-3.16.27-5.47.54-4.62.49-11,1.41-17.93,2.72s-13.22,2.79-17.71,4c-2.25.58-4.06,1.1-5.31,1.45a11.66,11.66,0,0,1-2,.49,10.27,10.27,0,0,1,1.88-.76c1.23-.43,3-1,5.26-1.67,4.47-1.33,10.73-2.88,17.71-4.21a177.61,177.61,0,0,1,18-2.52c2.32-.2,4.21-.28,5.51-.31A9.35,9.35,0,0,1,453.87,194.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.52,260s-.15-.2-.35-.61l-.86-1.82c-.74-1.59-1.76-3.92-3-6.8-2.43-5.78-5.54-13.86-8.85-22.82s-6.34-17.07-8.65-22.89l-2.75-6.88-.74-1.87a2.86,2.86,0,0,1-.21-.68,2.6,2.6,0,0,1,.34.62c.24.49.52,1.09.87,1.82.74,1.59,1.75,3.91,3,6.8,2.44,5.77,5.54,13.85,8.85,22.82s6.34,17.06,8.65,22.88l2.75,6.88c.3.75.54,1.37.74,1.88A3.19,3.19,0,0,1,381.52,260Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.49,238.45a2.59,2.59,0,0,1-.66.27l-1.95.65-7.17,2.33c-6.06,2-14.39,4.77-23.59,7.89s-17.58,5.85-23.67,7.69c-3.05.92-5.53,1.64-7.25,2.1l-2,.52a2.32,2.32,0,0,1-.7.13,3.15,3.15,0,0,1,.66-.27l1.94-.65,7.18-2.33c6.05-2,14.39-4.77,23.59-7.89s17.57-5.85,23.67-7.69c3.05-.92,5.52-1.64,7.24-2.1l2-.52A2.28,2.28,0,0,1,448.49,238.45Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.24,454.64c0,.14-98.61.26-220.23.26s-220.25-.12-220.25-.26,98.59-.27,220.25-.27S470.24,454.49,470.24,454.64Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.32,299.36c15.89-16,15.72-40.42,11.14-61.52-.77-3.53-1.06-7.34-3.31-10.14s-6.58-4.21-9.48-2.14c-2.41,1.72-3,5-4,7.79a21,21,0,0,1-6.87,9.46c-2,1.58-4.7,2.8-7.15,2-3.37-1.13-4.5-5.29-5.12-8.82q-1.72-9.87-3.47-19.73c-.62-3.53-1.26-7.13-3-10.28s-4.69-5.81-8.22-6.14-7.32,2.36-7.4,5.94a33.42,33.42,0,0,0,.7,4.41c.17,1.48-.22,3.22-1.53,3.88s-2.93-.07-4.17-.91c-4.29-2.9-7.59-7-10.73-11.17s-6.23-8.4-10.24-11.68-9.13-5.53-14.23-4.9-9.92,4.74-10.29,9.92,3.45,9.72,7.33,13.17a79.73,79.73,0,0,0,19.23,12.63,6.57,6.57,0,0,1,3.28,2.45c1.19,2.21-.61,4.95-2.79,6.15-2.47,1.35-5.37,1.6-8.06,2.42s-5.44,2.58-6,5.37c-.79,3.87,2.91,7.09,6.33,9a68.5,68.5,0,0,0,22,7.88c2.77.48,5.65.81,8.07,2.25s4.26,4.38,3.45,7.1-3.91,4.1-6.72,4.09-5.5-1-8.27-1.55c-5.18-.94-11.38.53-13.72,5.28-1.53,3.13-1,7,.61,10.09a26.13,26.13,0,0,0,6.94,7.73,68.84,68.84,0,0,0,32.65,15.07c11.94,1.85,22.55,1,33-5.11",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.46,315.05a156.79,156.79,0,0,0-11.05-28,321.36,321.36,0,0,0-18.74-31.73l-5.33-8.06c-1.76-2.65-3.51-5.27-5.37-7.72A161,161,0,0,0,102.45,226c-3.87-4.12-7.69-7.88-11.29-11.38s-7-6.69-10.29-9.46a125.8,125.8,0,0,0-16.28-11.94c-2-1.26-3.63-2.18-4.72-2.79l-1.25-.69a2.18,2.18,0,0,0-.44-.21,3,3,0,0,0,.41.27l1.21.75c1.08.64,2.66,1.6,4.66,2.89a134.24,134.24,0,0,1,16.11,12.08c3.22,2.79,6.62,6,10.21,9.49s7.38,7.3,11.23,11.42a161.09,161.09,0,0,1,11.45,13.48c1.85,2.45,3.57,5,5.33,7.7s3.53,5.34,5.34,8.06a329.18,329.18,0,0,1,18.74,31.63A160.2,160.2,0,0,1,154,315.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.78,239.54a6.57,6.57,0,0,0,.07-1.56c0-1,0-2.47-.1-4.27-.14-3.6-.51-8.57-.93-14s-.71-10.43-.8-14c0-1.79-.07-3.25-.08-4.25a6.29,6.29,0,0,0-.08-1.57,8,8,0,0,0-.17,1.56c-.08,1-.12,2.46-.13,4.26,0,3.61.18,8.59.61,14.08s.82,10.28,1.11,14c.13,1.68.23,3.1.31,4.25A6.72,6.72,0,0,0,113.78,239.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.91,239.33a11,11,0,0,0,1.85-.11c1.18-.11,2.89-.28,5-.41,4.23-.31,10.09-.53,16.57-.49s12.34.34,16.58.68c2.12.15,3.83.32,5,.43a8.86,8.86,0,0,0,1.85.11,11,11,0,0,0-1.82-.37c-1.17-.18-2.88-.43-5-.64-4.24-.46-10.12-.83-16.62-.88a162,162,0,0,0-16.61.69c-2.12.19-3.83.43-5,.62A8.85,8.85,0,0,0,66.91,239.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.7,286.32a3,3,0,0,0,.21-.61l.48-1.78c.4-1.55.93-3.81,1.55-6.6,1.24-5.6,2.71-13.37,4.22-22s2.91-16.38,4-22c.55-2.73,1-5,1.35-6.64.14-.72.26-1.32.36-1.81a2.77,2.77,0,0,0,.08-.64s-.1.2-.21.61l-.48,1.78c-.41,1.55-.94,3.8-1.56,6.6-1.24,5.59-2.71,13.37-4.22,22s-2.9,16.39-4,22c-.56,2.72-1,5-1.35,6.63-.15.73-.26,1.33-.36,1.81A2.82,2.82,0,0,0,142.7,286.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.93,277.88a3.16,3.16,0,0,0,.64.13l1.86.27,6.83.92c5.77.77,13.72,1.93,22.51,3.22s16.76,2.39,22.55,3c2.89.33,5.23.57,6.85.71l1.87.14a2.55,2.55,0,0,0,.66,0,2.19,2.19,0,0,0-.64-.14l-1.86-.27-6.83-.91c-5.77-.78-13.72-1.94-22.51-3.23s-16.76-2.39-22.54-3c-2.9-.33-5.24-.57-6.86-.71l-1.87-.14A1.86,1.86,0,0,0,78.93,277.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.32,118.08a11.14,11.14,0,0,0,3.83-10.5,14.8,14.8,0,0,0-6.37-9.48c-1.49-1-3.34-1.84-5.07-1.32a4.73,4.73,0,0,0-3.08,3.71,9.57,9.57,0,0,0,.58,5c1.89,5.48,4.73,10.43,10.11,12.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.39,127.44a26.05,26.05,0,0,1,23-6c2.05.47,4.35,1.56,4.69,3.63s-1.52,3.84-3.34,4.89a22.23,22.23,0,0,1-24.6-2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.75,84.11a13,13,0,0,0-10.07,1.73,22.92,22.92,0,0,0-7.2,7.52c-3.63,5.73-4.9,13.42-5.06,20.19,7.51-.3,13.94-6.21,17-9.41,4.85-5.06,10.55-17.16,5.32-20",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,137.67a26,26,0,0,0,1.87-2.83,47.52,47.52,0,0,0,4.24-12.07,24,24,0,0,0-.94-12.74,15.82,15.82,0,0,0-1.82-3.45c-.54-.75-.89-1.11-.93-1.08a33.2,33.2,0,0,1,2.25,4.72,25.14,25.14,0,0,1,.69,12.41,55.59,55.59,0,0,1-4,12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,137.76l3.91-5c3.3-4.27,7.86-10.16,13-16.59s9.85-12.2,13.28-16.37l4.05-4.94a13.14,13.14,0,0,0,1.41-1.88A14.6,14.6,0,0,0,361,94.62c-1,1.11-2.46,2.75-4.23,4.79-3.54,4.07-8.33,9.79-13.46,16.23s-9.64,12.39-12.83,16.75c-1.59,2.18-2.86,4-3.72,5.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.71,125.87a4.79,4.79,0,0,0-1.31-.4,11,11,0,0,0-1.57-.3,19.19,19.19,0,0,0-2.11-.23,28.13,28.13,0,0,0-5.52.21A29.21,29.21,0,0,0,333.66,130a27.57,27.57,0,0,0-4.22,3.58,18.35,18.35,0,0,0-1.4,1.59,9.93,9.93,0,0,0-1,1.29c-.49.73-.42,1.07-.38,1.1a46.35,46.35,0,0,1,3.11-3.6,30.32,30.32,0,0,1,4.23-3.38,34.31,34.31,0,0,1,5.87-3,33.83,33.83,0,0,1,6.38-1.72,30.78,30.78,0,0,1,5.4-.37C354.79,125.56,356.68,126,356.71,125.87Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.42,454.51l-133.87-.62c-16.1-.07-29.09-13.54-29-30.09L137,78.94c.07-16.55,13.18-29.92,29.29-29.84l133.87.62c16.1.07,29.09,13.54,29,30.09l-1.46,344.86C327.64,441.22,314.53,454.59,298.42,454.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.55,364.13a2.95,2.95,0,1,1-2.94-2.95A2.95,2.95,0,0,1,318.55,364.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.61,370.6a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.83,61.1,276.06,61a6.65,6.65,0,0,0-6.53,6.77l0,4.85A6.65,6.65,0,0,1,263,79.37l-52.19-.24a6.66,6.66,0,0,1-6.47-6.83l0-4.85a6.65,6.65,0,0,0-6.47-6.83l-9.42,0L165,60.47a21.06,21.06,0,0,0-21.16,21l-1.43,337.89a21.06,21.06,0,0,0,21,21.16l137.81.64a21.07,21.07,0,0,0,21.16-21L323.8,82.26A21.08,21.08,0,0,0,302.83,61.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.58,327.74c1.18-.88,58.81-26.27,58.81-26.27l-67.32-33.58L142.84,322Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.1 266.85 204.21 241.89 151.44 212.63 143.3 214.67 143.1 262.01 155.1 266.85",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.1 266.85 204.21 241.89 151.44 212.63 143.3 214.67 143.1 262.01 155.1 266.85",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.07 209.23 296.44 138.53 146.47 89.52 145.07 209.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.31 393.35 212.48 357.85 315.45 418.43 290.92 439.94 203.05 439.94 143.31 403.43 143.31 393.35",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.1 354.01 311.64 404.73 321.18 403.65 321.18 354.88 274.3 330.07 226.1 354.01",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.16 305.58 320.81 350.95 320.81 291.64 291.63 279.14 240.16 305.58",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.02 330.58 201.33 356.54 258.75 326.8 213.13 303.6 154.02 330.58",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.04 241.56 292.06 274.77 323.14 258.9 323.34 236.64 278.07 214.67 225.04 241.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.5 270.53 223.52 303.74 254.6 287.87 254.8 265.61 209.52 243.64 156.5 270.53",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.78 210.84 220.4 238.19 271.34 210.84 218.56 186.76 165.78 210.84",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.34,385.62a6.72,6.72,0,0,1-1-.5l-2.82-1.59-10.85-6.27-40.16-23.55-.83-.49.86-.44L269.23,326v1.22l-39.34-21-1.24-.66,1.25-.66,54.64-28.68v1.39l-6.52-3.3-122.4-62.1-1.15-.58,1.17-.56,65-31,18-8.49,4.74-2.18,1.23-.54a2.18,2.18,0,0,1,.43-.15,1.62,1.62,0,0,1-.39.24l-1.18.62L238.78,172l-17.88,8.81-64.71,31.47V211.1l122.53,61.83,6.52,3.3,1.35.69-1.34.7-54.68,28.62v-1.32L269.86,326l1.16.62-1.17.59L217,353.73l0-.93,39.92,24,10.7,6.51,2.75,1.72A5.69,5.69,0,0,1,271.34,385.62Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.59,136.64c0-10-10.48-16.3-21.17-11.3a12.13,12.13,0,0,0-5.62,5.39c-2.69,5.21-1.5,11.16.93,16.1l8.32,21.08a3.58,3.58,0,0,0,6.68,0l8.15-21.19C259.71,140.24,259.59,136.64,259.59,136.64Zm-10,8.68c-7.19,4.18-14.47-3.54-10.53-11.16a6,6,0,0,1,2.28-2.42c7.19-4.18,14.47,3.54,10.53,11.16A6,6,0,0,1,249.55,145.32Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.63 245.78 243.39 234 274.1 248.87 274.1 261.11 243.63 245.78",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.1 248.87 312.24 229.92 312.24 243.11 274.1 261.11 274.1 248.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.39 234 280.82 215.28 312.24 229.92 274.1 248.87 243.39 234",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.4 239.09 247.4 244.8 250.4 246.15 250.4 240.69 247.4 239.09",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.2 241.2 252.2 246.92 255.21 248.27 255.21 242.81 252.2 241.2",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.01 171.45 147.01 156.12 183.36 173.73 183.36 188.21 147.01 171.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.36 173.73 228.52 151.29 228.52 166.91 183.36 188.21 183.36 173.73",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.01 156.12 191.31 133.97 228.52 151.29 183.36 173.73 147.01 156.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.76 162.14 151.76 168.91 155.31 170.51 155.31 164.04 151.76 162.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.44 164.65 157.44 171.41 161 173.02 161 166.55 157.44 164.65",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.59,299.59v12.08l13,6.39V305.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.09 297.67 269.54 305.58 269.54 318.06 286.09 308.82 286.09 297.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.59 299.59 272.99 291.64 286.09 297.67 269.54 305.58 256.59 299.59",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.19 308.26 261.19 313.97 264.19 315.33 264.19 309.87 261.19 308.26",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.94,293.34v12.08l12.95,6.39V299.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.45 291.42 164.89 299.33 164.89 311.81 181.45 302.57 181.45 291.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.94 293.34 168.35 285.39 181.45 291.42 164.89 299.33 151.94 293.34",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.54 302.01 156.54 307.72 159.54 309.08 159.54 303.62 156.54 302.01",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.65,213.6v12.09l12.95,6.39V219.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.16 211.69 218.6 219.6 218.6 232.08 235.16 222.84 235.16 211.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.65 213.6 222.06 205.66 235.16 211.69 218.6 219.6 205.65 213.6",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.25 222.28 210.25 227.99 213.25 229.35 213.25 223.88 210.25 222.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.25,317.13v12.09l12.95,6.38V323.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.76 315.21 204.21 323.13 204.21 335.6 220.76 326.37 220.76 315.21",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.25 317.13 207.66 309.19 220.76 315.21 204.21 323.13 191.25 317.13",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.85 325.8 195.85 331.52 198.85 332.87 198.85 327.41 195.85 325.8",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.73,346.32v15.15L272,377.54V361.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.79 350.72 272.03 361.9 272.03 377.54 292.79 365.96 292.79 350.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.73 346.31 265.31 336.35 292.79 350.72 272.03 361.9 244.73 346.31",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.04 360.33 255.04 367.49 258.81 369.75 258.81 362.67 255.04 360.33",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.06,377.5v15.15l27.3,16.08V393.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.94 375.43 206.36 393.08 206.36 408.73 239.03 390.62 238.94 375.43",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.06 377.5 213.52 360.81 239.03 375.49 206.36 393.08 179.06 377.5",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.37 391.51 189.37 398.68 193.13 400.94 193.13 393.85 189.37 391.51",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.4 320.85 282.4 381.36 299.44 390.17 299.44 328.9 282.4 320.85",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.99 315.05 282.4 320.85 299.44 328.9 310.9 322.44 294.99 315.05",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.44 328.9 299.44 390.17 309.81 384.59 310.9 322.44 299.44 328.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.39 271.84 210.39 332.35 227.43 341.16 227.43 279.89 210.39 271.84",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.97 266.03 210.39 271.84 227.43 279.89 238.89 273.43 222.97 266.03",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.43 279.89 227.43 341.16 237.79 336.05 238.89 273.43 227.43 279.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.12,386.91v15.15l27.31,16.08V402.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.18 391.32 245.43 402.5 245.43 418.14 266.18 406.56 266.18 391.32",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.12 386.91 238.94 375.43 266.18 391.32 245.43 402.5 218.12 386.91",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.43 400.92 228.43 408.09 232.2 410.35 232.2 403.26 228.43 400.92",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.84 206.28 229.12 183.87 298.36 148.63 321.08 182.51 278.84 206.28",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.1 226.86 323.44 188.06 284.89 210 323.1 226.86",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.81,265.72a2.95,2.95,0,1,1-2.95-3A3,3,0,0,1,293.81,265.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,272.19a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.34,258.49a3,3,0,1,1-3-3A2.95,2.95,0,0,1,213.34,258.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.39,265a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.92,299.67a2.95,2.95,0,1,1-2.95-2.95A2.95,2.95,0,0,1,173.92,299.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,306.14a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.87,267.89a2.95,2.95,0,1,1-3-2.95A2.95,2.95,0,0,1,176.87,267.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.92,274.36a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.67,265a3,3,0,1,1-2.95-2.94A2.95,2.95,0,0,1,249.67,265Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.72,271.44a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.26,287.07a2.95,2.95,0,1,1-2.95-2.95A2.95,2.95,0,0,1,296.26,287.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.31,293.54a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.14,304.42a2.95,2.95,0,1,1-2.95-2.95A2.95,2.95,0,0,1,298.14,304.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.19,310.89a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.43,340.42a2.95,2.95,0,1,1-3-2.95A2.95,2.95,0,0,1,215.43,340.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.48,346.89a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.39,
    cy: 391.85,
    r: 2.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.39,398.32a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,424.11a3,3,0,1,1-2.95-2.95A2.95,2.95,0,0,1,256,424.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,430.58a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.26,415.2a2.95,2.95,0,1,1-2.95-2.95A2.95,2.95,0,0,1,233.26,415.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.31,421.67a20.26,20.26,0,0,1,0-6.47,19.52,19.52,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35,408.73a3,3,0,1,1-3-3A2.95,2.95,0,0,1,285.35,408.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4,415.2a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.99,
    cy: 351.92,
    r: 2.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,358.39a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.38,323.13a2.95,2.95,0,1,1-2.95-2.95A2.95,2.95,0,0,1,248.38,323.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.43,329.6a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.87,326.37a2.95,2.95,0,1,1-3-2.95A2.95,2.95,0,0,1,176.87,326.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.92,332.84a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.09,299.67a2.95,2.95,0,1,1-2.95-2.95A2.95,2.95,0,0,1,313.09,299.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.14,306.14a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.18,255.54a2.95,2.95,0,1,1-2.95-2.95A2.95,2.95,0,0,1,305.18,255.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.23,262a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.5,
    cy: 216.54,
    r: 2.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.5,223a19.52,19.52,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.05,272.19a2.95,2.95,0,1,1-3-2.95A2.95,2.95,0,0,1,189.05,272.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.1,278.66a20.26,20.26,0,0,1,0-6.47,19.52,19.52,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.71,195.49a3,3,0,1,1-3-3A2.95,2.95,0,0,1,223.71,195.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.76,202a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.86,189a2.95,2.95,0,1,1-2.95-3A2.95,2.95,0,0,1,283.86,189Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.91,195.49a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.49,186.3a3,3,0,1,1-2.95-3A2.95,2.95,0,0,1,300.49,186.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.54,192.77a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.81,164.54a2.95,2.95,0,1,1-2.95-2.95A3,3,0,0,1,293.81,164.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,171a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.18,214.67a2.95,2.95,0,1,1-3-2.95A2.95,2.95,0,0,1,201.18,214.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.23,221.14a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.74,186.76a3,3,0,1,1-2.95-2.95A2.95,2.95,0,0,1,269.74,186.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.79,193.23a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.91,120.32a3,3,0,1,1-2.95-2.95A2.95,2.95,0,0,1,186.91,120.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,126.78a10.35,10.35,0,0,1-.26-3.23,10.35,10.35,0,0,1,.26-3.23,10,10,0,0,1,.26,3.23A10,10,0,0,1,184,126.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.76,136.47a2.95,2.95,0,1,1-2.95-2.95A2.95,2.95,0,0,1,220.76,136.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.81,142.94a10.41,10.41,0,0,1-.26-3.23,10.45,10.45,0,0,1,.26-3.24,10.45,10.45,0,0,1,.26,3.24A10.41,10.41,0,0,1,217.81,142.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,187.49a3,3,0,1,1-3-3A2.95,2.95,0,0,1,167,187.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,194a20.26,20.26,0,0,1,0-6.47,20.26,20.26,0,0,1,0,6.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.91,139.42a3,3,0,1,1-2.95-2.95A2.95,2.95,0,0,1,169.91,139.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,145.89a10.06,10.06,0,0,1-.26-3.23,10.1,10.1,0,0,1,.26-3.24,10.45,10.45,0,0,1,.26,3.24A10.41,10.41,0,0,1,167,145.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.86 276.97 321.18 264.08 321.08 287.33 296.86 276.97",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.85 359.41 142.57 386.91 142.57 335.6 148.47 332.97 195.85 359.41",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.43,386.91a3.4,3.4,0,1,1-3.4-3.4A3.4,3.4,0,0,1,275.43,386.91Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.54 144.22 323.51 149.38 323.51 176.12 306.54 144.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.68,108.5l-.1-29.18A21.06,21.06,0,0,0,302.83,61.1L276.06,61a6.65,6.65,0,0,0-6.53,6.77l0,4.85A6.65,6.65,0,0,1,263,79.37l-52.19-.24a6.66,6.66,0,0,1-6.47-6.83l0-4.85a6.65,6.65,0,0,0-6.47-6.83l-9.42,0L165,60.47A21,21,0,0,0,150.75,66c-2.35,4.53-4.92,11-3.74,15.89l176.54,57.47Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.68,108.5l-.1-29.18A21.06,21.06,0,0,0,302.83,61.1L276.06,61a6.65,6.65,0,0,0-6.53,6.77l0,4.85A6.65,6.65,0,0,1,263,79.37l-52.19-.24a6.66,6.66,0,0,1-6.47-6.83l0-4.85a6.65,6.65,0,0,0-6.47-6.83l-9.42,0L165,60.47A21,21,0,0,0,150.75,66c-2.35,4.53-4.92,11-3.74,15.89l176.54,57.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.83,61.1l.72,0a16.21,16.21,0,0,1,2.13.18,19.74,19.74,0,0,1,7.89,2.76A20.4,20.4,0,0,1,318.36,68a21.15,21.15,0,0,1,4,6.31,21.86,21.86,0,0,1,1.54,8.55q0,4.66,0,9.93c-.1,28.07-.24,68.68-.42,118.86s-.43,109.93-.69,176.28q0,12.43-.1,25.18,0,3.18,0,6.39a22.49,22.49,0,0,1-.84,6.41,21,21,0,0,1-2.71,5.92,22.48,22.48,0,0,1-4.4,4.84,21.27,21.27,0,0,1-12.16,4.67c-1.11.07-2.21.05-3.31.05l-3.3,0-6.63,0-26.83-.12L207.38,441l-28.16-.13L165,440.76a22.26,22.26,0,0,1-13.68-3.84A21.47,21.47,0,0,1,143,425.37a22.9,22.9,0,0,1-.85-7.12l0-7.1q.06-14.17.12-28.17.12-28,.23-55.07c.16-36.11.31-70.94.46-104.12s.29-64.7.42-94.21q.1-22.13.2-42.69c0-1.72,0-3.42,0-5.11,0-.85.08-1.71.13-2.56s.22-1.68.44-2.5a21.52,21.52,0,0,1,4.46-8.9,21.36,21.36,0,0,1,17.19-7.53l18.36.09,8.83,0,4.33,0a6.71,6.71,0,0,1,4.13,1.17A7,7,0,0,1,204.09,65a11.57,11.57,0,0,1,.41,4.16c0,.68,0,1.37,0,2a14.87,14.87,0,0,0,0,2,6.68,6.68,0,0,0,1.57,3.54,6.15,6.15,0,0,0,3.22,2,7.1,7.1,0,0,0,1.9.2h1.94l7.61,0,27.77.15,12.25.07c1,0,1.95,0,2.87,0a6.17,6.17,0,0,0,2.59-.9,6.69,6.69,0,0,0,3-4.24,12.21,12.21,0,0,0,.17-2.56c0-.85,0-1.69,0-2.52a13.33,13.33,0,0,1,.12-2.45,6.86,6.86,0,0,1,.8-2.25,6.59,6.59,0,0,1,3.37-3,10.58,10.58,0,0,1,4.18-.43l13.66.09,8.4.06,2.87,0s-1,0-2.87,0h-8.4l-13.66,0a10.16,10.16,0,0,0-4.12.43,6.46,6.46,0,0,0-3.28,2.88,6.94,6.94,0,0,0-.77,2.2,13.74,13.74,0,0,0-.11,2.42c0,.83,0,1.67,0,2.52a11.46,11.46,0,0,1-.18,2.6,6.85,6.85,0,0,1-3.06,4.38,6.37,6.37,0,0,1-2.67.94c-1,.08-1.92,0-2.9,0l-12.25,0-27.77-.11-7.61,0h-1.94a7.45,7.45,0,0,1-2-.2A6.57,6.57,0,0,1,205.87,77a7,7,0,0,1-1.64-3.71,15.7,15.7,0,0,1-.06-2.05v-2a11,11,0,0,0-.39-4,6.65,6.65,0,0,0-2.44-3.22,6.34,6.34,0,0,0-3.94-1.1l-4.33,0-8.83,0-18.37-.07A21,21,0,0,0,149,68.07a21.22,21.22,0,0,0-4.37,8.74c-.21.8-.28,1.64-.43,2.46s-.11,1.66-.12,2.51c0,1.69,0,3.4,0,5.11q-.09,20.53-.17,42.69c-.11,29.51-.24,61-.37,94.21s-.28,68-.43,104.12Q143,355,142.84,383q0,14-.11,28.17l0,7.11a22.43,22.43,0,0,0,.83,7,21,21,0,0,0,8.08,11.26A21.74,21.74,0,0,0,165,440.24l14.22.06,28.17.13,55.05.26,26.83.13,6.63,0,3.3,0c1.1,0,2.2,0,3.28-.05a20.78,20.78,0,0,0,11.88-4.56,22,22,0,0,0,4.3-4.73,20.68,20.68,0,0,0,2.65-5.77,21.84,21.84,0,0,0,.81-6.28q0-3.21,0-6.39.06-12.75.11-25.19c.31-66.34.58-126.09.8-176.27s.45-90.79.59-118.86q0-5.26.05-9.93a21.55,21.55,0,0,0-1.5-8.49,20.71,20.71,0,0,0-3.94-6.28,20.47,20.47,0,0,0-4.74-3.91,19.93,19.93,0,0,0-7.84-2.8,15.42,15.42,0,0,0-2.13-.2C303.07,61.13,302.83,61.1,302.83,61.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.37,259.79c14.81.37,29.78.76,44.1,4.56s28.15,11.36,36.64,23.5c9.36,13.36,11.22,30.44,12.15,46.72A521.33,521.33,0,0,1,457,415.65c-1.34,13.64-6.18,26.32-18.87,31.51-15.26,6.25-35.77,0-35.77,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.09,443.91s.19,0,.56,0l1.65,0,6.33-.05a71.69,71.69,0,0,0,10-.52c1-.16,2-.27,3-.53l1.54-.34c.52-.14,1-.31,1.57-.46,1.07-.28,2.11-.73,3.2-1.13a30.58,30.58,0,0,0,3.2-1.58,23.14,23.14,0,0,0,6-4.76,18.06,18.06,0,0,0,3.91-7.2,85.86,85.86,0,0,0,2.25-18.23c.2-6.49.13-13.31.19-20.39s.06-14.39.1-21.89.11-14.83-.13-21.9a148.81,148.81,0,0,0-1.92-20.26c-2.16-12.79-6.63-23.88-12.41-31.82a71,71,0,0,0-8.84-9.82c-2.85-2.67-5.41-4.85-7.51-6.62l-4.86-4.05-1.25-1.07a4.85,4.85,0,0,1-.42-.38s.16.11.45.34l1.29,1,4.92,4c2.12,1.74,4.71,3.9,7.58,6.56a70.17,70.17,0,0,1,8.94,9.82c5.85,8,10.39,19.11,12.59,32a148.21,148.21,0,0,1,1.94,20.33c.26,7.08.18,14.41.15,21.91s-.07,14.82-.11,21.9,0,13.89-.22,20.4a86.42,86.42,0,0,1-2.31,18.33,18.49,18.49,0,0,1-4,7.35,23.61,23.61,0,0,1-6.07,4.81,32.26,32.26,0,0,1-3.24,1.59c-1.11.4-2.17.84-3.25,1.12l-1.58.45-1.56.34c-1,.25-2,.35-3,.51a69.38,69.38,0,0,1-10,.43l-6.33,0-1.65,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.71,370.65a14.77,14.77,0,0,1,5.19-.93,15.07,15.07,0,0,1,5.26.44c0,.15-2.36-.06-5.24.08S448.74,370.8,448.71,370.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.72,260.56h.38l1.13,0c1,0,2.46,0,4.34.17a66.55,66.55,0,0,1,15.6,3.33l2.43.9,1.26.47,1.24.56,2.57,1.17c.88.39,1.71.89,2.6,1.35a71.05,71.05,0,0,1,10.6,6.93,73,73,0,0,1,10.2,9.59,53.69,53.69,0,0,1,8.25,12.55c4.46,9.35,6.39,19.14,7.38,28s1,16.92,1,23.66,0,12.18.13,15.95c.06,1.86.1,3.31.13,4.34,0,.47,0,.84,0,1.12a2.29,2.29,0,0,1,0,.39,1.65,1.65,0,0,1,0-.38c0-.28,0-.66-.08-1.13-.07-1-.14-2.45-.22-4.33-.15-3.77-.23-9.22-.3-16s-.18-14.76-1.15-23.61-3-18.53-7.37-27.8a52.83,52.83,0,0,0-8.17-12.44,71.59,71.59,0,0,0-10.11-9.55,70.39,70.39,0,0,0-10.51-6.93c-.87-.46-1.7-1-2.57-1.36l-2.55-1.17-1.24-.57-1.24-.47-2.41-.92a69.87,69.87,0,0,0-15.5-3.47c-1.87-.16-3.34-.19-4.32-.26l-1.13-.07A1.65,1.65,0,0,1,384.72,260.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.46,260.53s3.63-9.59,16.56-7.77c0,0,5.76-.32,6.81,2.88,0,0-12.05-3-17.18,5.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.31,272.21h-7.57s-1.47-20-19.83-19.25C384.91,253,407.73,245.32,412.31,272.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.82 382.87 459.68 384.37 458.59 388.23 448.46 387.45 448.82 382.87",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.48,386.36a8.85,8.85,0,0,1,1.27-1.95l.15-.2.17.2,1.52,1.85-.35-.05,1.08-.8,1.13-.82.2-.15.15.21,1.39,2-.28-.05a9.26,9.26,0,0,1,2-1.16,8.42,8.42,0,0,1-1.72,1.49L456,387l-.12-.16-1.48-1.9.35.05-1.11.83-1.09.79-.2.15-.15-.2-1.44-1.9h.32A8.81,8.81,0,0,1,449.48,386.36Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,454.34s-2.1-6.84-1.68-9.74,4.31-5.52,4.31-5.52l-4.22-109.65s-.54-48,24.84-62.87l15.15-3.82,37.37-2.21c1.21.4,45.13,16.92,51.17,23.37L399,380.6s2.3,28.57,4.59,49.1c.47,4.2,3.62,24.94,3.62,24.94Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402.89,423.25c-.36,2.66-1.37,5.91-3.93,6.74a16.73,16.73,0,0,1-8,.11c-9.36-1.67-18-6.07-26.45-10.41-15.81-8.13-31.77-16.34-45.43-27.74-1.92-1.6-4-4.09-2.79-6.3,1.33-2.5,5.08-1.66,7.65-.47,26.82,12.36,52.12,25.7,78.94,38.07"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M308.56,269.55s-16.73,5.58-22.14,21.08c-6,17.12-9.94,50.36-9.94,50.36L293,343.07Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.92,283.9s9,11.8,13.34,26.14,6.86,55.89,6.86,55.89l-45-.62-2.39-36.57S386.19,267.73,417.92,283.9Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.38,305.56a5.33,5.33,0,0,1,1.25-1.17,6.11,6.11,0,0,1,4.73-.91c2.18.32,4.3,2,7.09,3.1a8,8,0,0,0,4.64.57c1.64-.35,3.07-1.53,4.57-2.68a12.6,12.6,0,0,1,2.5-1.57,4,4,0,0,1,3.11-.13,5.23,5.23,0,0,1,2.42,2.16c.62.9,1.12,1.88,1.77,2.76a4.85,4.85,0,0,0,2.54,2,5.93,5.93,0,0,0,3.34,0,12.83,12.83,0,0,0,3.26-1.41c1-.61,2-1.35,3.11-2a14.77,14.77,0,0,1,3.48-1.69,6.62,6.62,0,0,1,4,0,10.46,10.46,0,0,1,3.46,2.12c1,.87,2,1.83,3.05,2.66a7.73,7.73,0,0,0,3.56,1.74,7.31,7.31,0,0,0,4-.41c2.6-1,4.9-2.74,7.46-4.15a13.83,13.83,0,0,1,4.07-1.63,8.11,8.11,0,0,1,4.34.34c2.72,1.06,4.74,3.13,7.16,4.28a8.6,8.6,0,0,0,1.86.66,7.46,7.46,0,0,0,1.94.13,10.87,10.87,0,0,0,3.73-1.07c2.37-1.07,4.51-2.57,7-3.38a7.6,7.6,0,0,1,3.78-.33,7.08,7.08,0,0,1,3.29,1.68c1.83,1.53,3.28,3.48,5.37,4.13a6.23,6.23,0,0,0,3.15.09,23.24,23.24,0,0,0,3-.9c1.93-.68,3.95-1.38,5.91-.93a6.18,6.18,0,0,1,2.54,1.25c.73.56,1.37,1.18,2,1.74a10.79,10.79,0,0,0,2,1.45,6.41,6.41,0,0,0,2.16.69,9,9,0,0,0,4.09-.41,12.26,12.26,0,0,0,3.11-1.59,27.23,27.23,0,0,0,3.68-3.19l.9-.9a1.7,1.7,0,0,1,.32-.29s-.09.12-.28.33l-.86.94a26.21,26.21,0,0,1-3.65,3.28,12.36,12.36,0,0,1-3.14,1.65,9.2,9.2,0,0,1-4.21.47,6.65,6.65,0,0,1-2.27-.71,11.51,11.51,0,0,1-2-1.47c-1.29-1.1-2.57-2.51-4.41-2.88s-3.76.26-5.69.95a24.21,24.21,0,0,1-3.06.93,6.72,6.72,0,0,1-3.36-.09,8.22,8.22,0,0,1-3-1.81c-.88-.78-1.68-1.63-2.59-2.38a6.48,6.48,0,0,0-3.08-1.57,7.16,7.16,0,0,0-3.54.33c-2.35.78-4.49,2.27-6.91,3.37a11.13,11.13,0,0,1-3.89,1.12,8.06,8.06,0,0,1-2.08-.13,9.33,9.33,0,0,1-2-.7c-2.52-1.21-4.54-3.26-7.13-4.25a7.53,7.53,0,0,0-4.05-.32,13.76,13.76,0,0,0-3.92,1.57c-2.52,1.38-4.82,3.17-7.53,4.19a8,8,0,0,1-4.26.43,8.29,8.29,0,0,1-3.78-1.85c-2.17-1.69-3.91-3.89-6.36-4.7a6.11,6.11,0,0,0-3.69,0,14.3,14.3,0,0,0-3.36,1.63c-1.07.65-2.06,1.39-3.14,2a13.33,13.33,0,0,1-3.37,1.44,6.48,6.48,0,0,1-3.6,0,5.39,5.39,0,0,1-2.75-2.13c-.67-.92-1.17-1.91-1.76-2.79a5,5,0,0,0-2.22-2,3.59,3.59,0,0,0-2.82.12,11.74,11.74,0,0,0-2.43,1.51c-1.5,1.12-3,2.33-4.72,2.71a8.31,8.31,0,0,1-4.82-.63c-2.83-1.12-4.91-2.83-7-3.17a6.09,6.09,0,0,0-4.64.8A11.7,11.7,0,0,0,282.38,305.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.08,332.6a2.43,2.43,0,0,1,.44,0l1.3.13a11.19,11.19,0,0,0,4.92-.13c1.06-.23,2.25-.44,3.55-.67s2.69-.54,4.23-.72a11.74,11.74,0,0,1,5,.36c1.7.5,3.35,1.37,5.17,2a10,10,0,0,0,5.88.17c2-.49,4-1.42,6.21-2.17a11.69,11.69,0,0,1,7-.69c2.42.68,4.37,2.47,6.79,3.06a5.45,5.45,0,0,0,1.84.13,8.59,8.59,0,0,0,1.85-.44c1.22-.42,2.4-1,3.69-1.49a5.89,5.89,0,0,1,4.14-.14,14.8,14.8,0,0,1,3.5,2.32,8.39,8.39,0,0,0,1.74,1.05,4.72,4.72,0,0,0,2,.37,10.62,10.62,0,0,0,4-1.19,22.85,22.85,0,0,1,4.08-1.63,6.65,6.65,0,0,1,2.27-.16,6.35,6.35,0,0,1,2.18.71,38,38,0,0,1,3.66,2.51,8.9,8.9,0,0,0,1.86,1,4.78,4.78,0,0,0,1,.28l.51.09.52,0a11.37,11.37,0,0,0,4.08-.85c1.32-.48,2.62-1.05,4-1.45a7.93,7.93,0,0,1,4.21-.31,7.78,7.78,0,0,1,3.55,2.14,27.42,27.42,0,0,0,2.92,2.64,5.47,5.47,0,0,0,3.52,1,9.59,9.59,0,0,0,3.52-1.07c1.11-.54,2.16-1.17,3.23-1.76,2.1-1.17,4.41-2.24,6.8-2a13.09,13.09,0,0,1,6,2.81,34.43,34.43,0,0,0,5,3.37,14.66,14.66,0,0,0,5.24,1.42,18.64,18.64,0,0,0,4.86-.37,17.38,17.38,0,0,0,7-3.41,16,16,0,0,0,3.26-3.72c.28-.49.47-.89.61-1.14a3.52,3.52,0,0,1,.22-.39,2.44,2.44,0,0,1-.17.41c-.13.26-.3.67-.57,1.17a15.08,15.08,0,0,1-3.22,3.82,17.44,17.44,0,0,1-7.05,3.54,18.29,18.29,0,0,1-4.94.42,14.8,14.8,0,0,1-5.38-1.42,33.69,33.69,0,0,1-5.09-3.37,12.77,12.77,0,0,0-5.81-2.71c-2.24-.25-4.45.77-6.54,1.94-1.05.59-2.11,1.23-3.25,1.78a10.05,10.05,0,0,1-3.69,1.13,6,6,0,0,1-3.82-1.08,26.33,26.33,0,0,1-3-2.68,7.27,7.27,0,0,0-3.33-2,7.45,7.45,0,0,0-3.95.31c-1.32.39-2.61,1-3.95,1.44a11.71,11.71,0,0,1-4.26.89l-.57,0-.55-.1a4.53,4.53,0,0,1-1.09-.31,9.54,9.54,0,0,1-2-1.07,39.94,39.94,0,0,0-3.61-2.48,5.73,5.73,0,0,0-2-.65,6.42,6.42,0,0,0-2.09.14,23.81,23.81,0,0,0-4,1.6,11.25,11.25,0,0,1-4.18,1.24,5.56,5.56,0,0,1-2.18-.41,9,9,0,0,1-1.84-1.12,15.41,15.41,0,0,0-3.37-2.26,5.44,5.44,0,0,0-3.81.14c-1.24.43-2.43,1.05-3.69,1.48a8.74,8.74,0,0,1-2,.46,6.11,6.11,0,0,1-2-.14c-2.59-.66-4.52-2.45-6.81-3.09a11.29,11.29,0,0,0-6.78.65,65.5,65.5,0,0,1-6.26,2.16,10.32,10.32,0,0,1-6.09-.22c-1.86-.63-3.49-1.51-5.15-2a11.41,11.41,0,0,0-4.81-.38c-1.52.16-2.93.46-4.23.68s-2.49.4-3.55.62c-.53.1-1,.22-1.52.29a5.64,5.64,0,0,1-1.36,0c-.83-.09-1.53-.19-2.1-.27l-1.28-.18A2.28,2.28,0,0,1,277.08,332.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.73,356.18h.3l.87.09c.76.08,1.88.23,3.32.45,2.89.39,7,1.25,12.21,1.68a42.6,42.6,0,0,0,8.47-.15,20.13,20.13,0,0,1,4.79,0,8.55,8.55,0,0,1,2.43.71,12.18,12.18,0,0,1,2.18,1.42c1.36,1,2.65,2.33,4.32,2.83a4.52,4.52,0,0,0,2.55,0,17.63,17.63,0,0,0,2.54-1,9.9,9.9,0,0,1,2.75-.92,4.3,4.3,0,0,1,2.92.63c1.73,1.05,2.86,2.8,4.62,3.54s3.77.29,5.58-.24a21.78,21.78,0,0,1,5.62-1.31,6.31,6.31,0,0,1,2.81.59,10.08,10.08,0,0,1,2.31,1.56,19.8,19.8,0,0,0,4.12,3.18,6.27,6.27,0,0,0,4.74,0c1.54-.48,2.95-1.23,4.49-1.58a6.58,6.58,0,0,1,4.47.34,3.61,3.61,0,0,1,1.53,1.54,13.84,13.84,0,0,1,.7,1.9,4.25,4.25,0,0,0,.86,1.6,3.51,3.51,0,0,0,1.43.93,5.27,5.27,0,0,0,3.17,0,5.68,5.68,0,0,0,2.37-1.46,9.89,9.89,0,0,0,1.45-1.9,21.52,21.52,0,0,0,1.4-3c.14-.33.24-.6.32-.81a1.16,1.16,0,0,1,.13-.27,1.33,1.33,0,0,1-.08.29l-.27.83a18.7,18.7,0,0,1-1.33,3.09,9.37,9.37,0,0,1-1.44,2,6,6,0,0,1-2.46,1.57,5.56,5.56,0,0,1-3.36.05,3.79,3.79,0,0,1-1.59-1,4.61,4.61,0,0,1-1-1.72,14.49,14.49,0,0,0-.69-1.84,3.29,3.29,0,0,0-1.37-1.37,6.16,6.16,0,0,0-4.19-.26c-1.46.33-2.88,1.08-4.45,1.59a9.25,9.25,0,0,1-2.49.49,5.84,5.84,0,0,1-2.59-.5,20.2,20.2,0,0,1-4.24-3.24,10.52,10.52,0,0,0-2.2-1.49,6,6,0,0,0-2.59-.53,21.66,21.66,0,0,0-5.48,1.29,15.27,15.27,0,0,1-2.9.64,6,6,0,0,1-3-.41c-1.95-.85-3.09-2.63-4.69-3.58a3.77,3.77,0,0,0-2.59-.56,9.37,9.37,0,0,0-2.6.87,17.64,17.64,0,0,1-2.61,1.07,5,5,0,0,1-2.83,0c-1.84-.57-3.14-1.9-4.48-2.93a11.31,11.31,0,0,0-2.08-1.37,8.14,8.14,0,0,0-2.3-.69,19.79,19.79,0,0,0-4.68,0,43.05,43.05,0,0,1-8.54.09c-5.21-.48-9.33-1.4-12.21-1.85l-3.31-.55-.86-.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.33,422.87l.3-.12.87-.3c.77-.27,1.91-.68,3.38-1.16A25.89,25.89,0,0,1,302.4,420a8.18,8.18,0,0,1,3.52.58,16.1,16.1,0,0,0,3.75,1.07,8.11,8.11,0,0,0,4.1-.92,23.33,23.33,0,0,1,4.41-1.77,10.82,10.82,0,0,1,5.1.3c1.69.45,3.36,1.12,5.1,1.63a11.1,11.1,0,0,0,5.43.46,34.28,34.28,0,0,0,5.43-2.11,9.09,9.09,0,0,1,3-.71,5.44,5.44,0,0,1,3.06.81c1.83,1.08,3.14,2.86,5.06,3.57a5,5,0,0,0,2.95.07,18.07,18.07,0,0,0,2.86-1.09,21,21,0,0,1,2.88-1.14,5.43,5.43,0,0,1,3.12-.07,6.14,6.14,0,0,1,2.54,1.69c.7.71,1.32,1.45,2,2.05a5.56,5.56,0,0,0,5.08,1.07c1.77-.35,3.44-1,5.13-1.49a10.41,10.41,0,0,1,2.59-.39,4.79,4.79,0,0,1,2.49.61,5,5,0,0,1,1.81,1.68c.46.66.82,1.35,1.19,2a5.56,5.56,0,0,0,2.91,2.9,4.92,4.92,0,0,0,3.7-.38,8.63,8.63,0,0,0,2.73-2.08,25.71,25.71,0,0,0,2.89-4.8,20,20,0,0,1,1.88-3.05,6.88,6.88,0,0,1,.85-.91s-.28.32-.76,1a21.5,21.5,0,0,0-1.79,3.07,25.21,25.21,0,0,1-2.85,4.9,8.77,8.77,0,0,1-2.81,2.19,5.26,5.26,0,0,1-4,.43,6,6,0,0,1-3.14-3.05c-.75-1.29-1.45-2.79-2.86-3.51s-3.12-.58-4.75-.15-3.32,1.14-5.15,1.51a7.37,7.37,0,0,1-2.85.1,6,6,0,0,1-1.42-.43,6.1,6.1,0,0,1-1.24-.83c-.75-.64-1.38-1.39-2.06-2.07a5.52,5.52,0,0,0-2.34-1.56,5,5,0,0,0-2.83.07,21.35,21.35,0,0,0-2.81,1.12,16.8,16.8,0,0,1-2.95,1.12,5.55,5.55,0,0,1-3.25-.08c-2.12-.81-3.42-2.62-5.14-3.62a4.92,4.92,0,0,0-2.78-.73,8.54,8.54,0,0,0-2.84.67,34.06,34.06,0,0,1-5.51,2.12,11.57,11.57,0,0,1-5.66-.49c-1.78-.53-3.43-1.2-5.09-1.65a10.5,10.5,0,0,0-4.89-.32,23.49,23.49,0,0,0-4.34,1.72,8.56,8.56,0,0,1-4.3.92,16.27,16.27,0,0,1-3.82-1.12,7.88,7.88,0,0,0-3.39-.61,26.72,26.72,0,0,0-5.48,1.19l-3.4,1.07-.9.25A1,1,0,0,1,292.33,422.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.51,398.1a3.25,3.25,0,0,1-.57.37,13.14,13.14,0,0,1-1.76.8,14.46,14.46,0,0,1-7.05.73,14.88,14.88,0,0,1-2.32-.54c-.79-.25-1.58-.61-2.38-.95a5.57,5.57,0,0,0-2.54-.52,5.38,5.38,0,0,0-2.52,1.08c-.79.56-1.56,1.23-2.47,1.79a6,6,0,0,1-1.5.66,3.87,3.87,0,0,1-.83.12,3,3,0,0,1-.85,0c-2.28-.29-4.1-1.8-6.09-2.8a5.4,5.4,0,0,0-3.09-.79l-.38.05a2.53,2.53,0,0,0-.36.12,2.61,2.61,0,0,0-.7.32,6.25,6.25,0,0,0-1.17,1,20.15,20.15,0,0,1-2.2,2.34,3.23,3.23,0,0,1-1.49.68,2.73,2.73,0,0,1-1.6-.23,6,6,0,0,1-2.12-2.1,20.11,20.11,0,0,0-1.59-2.18,5.57,5.57,0,0,0-4.25-1.69,6.28,6.28,0,0,0-3.59,1.45A8.64,8.64,0,0,0,293,400a4.53,4.53,0,0,0-.81,2.39,1.93,1.93,0,0,1,0-.67,4.43,4.43,0,0,1,.66-1.83,8.56,8.56,0,0,1,2.08-2.27,6.65,6.65,0,0,1,3.75-1.59,5.92,5.92,0,0,1,4.59,1.77A21.52,21.52,0,0,1,304.9,400a5.57,5.57,0,0,0,1.94,1.92,2.4,2.4,0,0,0,2.59-.41,22.49,22.49,0,0,0,2.13-2.28,6.53,6.53,0,0,1,1.27-1.12,3.65,3.65,0,0,1,.8-.37l.42-.14.44-.06a6,6,0,0,1,3.38.84c2,1,3.84,2.51,5.91,2.77a4.3,4.3,0,0,0,2.86-.69c.86-.52,1.64-1.18,2.46-1.75a4.92,4.92,0,0,1,5.5-.57c.81.36,1.57.71,2.33,1a15.4,15.4,0,0,0,2.25.56,14.86,14.86,0,0,0,6.93-.56C347.69,398.56,348.48,398.05,348.51,398.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.31,449.59a1.19,1.19,0,0,1,.3.08l.37.12.52.08a6.26,6.26,0,0,0,3.35-.82A25.33,25.33,0,0,1,303,446.8a5.83,5.83,0,0,1,1.73-.09,5.63,5.63,0,0,1,1.75.58,26.17,26.17,0,0,1,3.22,2.26,5.75,5.75,0,0,0,3.84,1.36,13.76,13.76,0,0,0,4.29-1.55,10.24,10.24,0,0,1,2.38-.79,7.11,7.11,0,0,1,2.6.06c1.74.32,3.37,1.06,5.09,1.53a10.68,10.68,0,0,0,5.39.08,38.46,38.46,0,0,0,5.47-1.81,25.23,25.23,0,0,1,5.82-1.68,11,11,0,0,1,6.17,1c1.94.84,3.71,1.92,5.58,2.67a8.64,8.64,0,0,0,5.71.53c3.73-1.07,6.46-4.09,10-5.26a8.18,8.18,0,0,1,5.35,0,18.68,18.68,0,0,1,4.47,2.31c1.35.89,2.62,1.79,3.91,2.52a14.33,14.33,0,0,0,3.93,1.58,14.8,14.8,0,0,0,7.23-.31,15,15,0,0,0,4.9-2.51,15.24,15.24,0,0,0,3.2-3.47,1.56,1.56,0,0,1-.15.28l-.49.78a13.28,13.28,0,0,1-2.44,2.57A15.19,15.19,0,0,1,397,452a13.89,13.89,0,0,1-11.44-1.2c-1.32-.73-2.59-1.63-3.94-2.5a18.1,18.1,0,0,0-4.38-2.24,7.67,7.67,0,0,0-5.05,0,21.68,21.68,0,0,0-4.82,2.63,19.22,19.22,0,0,1-5.22,2.68,9.26,9.26,0,0,1-6-.54c-1.92-.78-3.69-1.86-5.59-2.69a10.53,10.53,0,0,0-5.9-.93,24.81,24.81,0,0,0-5.7,1.63,37.93,37.93,0,0,1-5.55,1.83,11.24,11.24,0,0,1-5.62-.11c-1.77-.49-3.38-1.23-5-1.54a6.48,6.48,0,0,0-2.44-.07,9.5,9.5,0,0,0-2.28.74,14.1,14.1,0,0,1-4.44,1.56,6.09,6.09,0,0,1-4.09-1.46,26.66,26.66,0,0,0-3.15-2.26,5.43,5.43,0,0,0-1.64-.57,5.21,5.21,0,0,0-1.63.06,26.21,26.21,0,0,0-5.1,2.16,6.2,6.2,0,0,1-3.44.73c-.21,0-.38-.06-.53-.1l-.36-.15A1.42,1.42,0,0,1,293.31,449.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.78,277.65s.3.36,1,.9a8.17,8.17,0,0,0,3.44,1.5,20.08,20.08,0,0,0,6,.12c1.17-.09,2.43-.21,3.78-.19a11.73,11.73,0,0,1,4.2.75,39.18,39.18,0,0,1,4.14,2.17,14.4,14.4,0,0,0,2.23,1,9.59,9.59,0,0,0,2.47.4,24.71,24.71,0,0,0,5.31-.6,19.61,19.61,0,0,1,5.77-.44,14.09,14.09,0,0,1,5.61,2.33,15.34,15.34,0,0,0,5.6,2.49,8.86,8.86,0,0,0,3.11-.21,19.44,19.44,0,0,0,3-1.14,38.26,38.26,0,0,1,6.2-2.64,8.91,8.91,0,0,1,3.45-.2,9.9,9.9,0,0,1,3.19,1.19c1.95,1.1,3.61,2.52,5.52,3.4a10.24,10.24,0,0,0,6,.74,36.69,36.69,0,0,0,5.79-1.5,32.45,32.45,0,0,1,5.61-1.35,15.38,15.38,0,0,1,5.44.34,68.34,68.34,0,0,1,9.12,3.37,15.34,15.34,0,0,0,7.74,1.23,18.37,18.37,0,0,0,5.8-1.46,11.26,11.26,0,0,0,4.1-3,6.32,6.32,0,0,1-.86,1,10.74,10.74,0,0,1-3.16,2.16,18.67,18.67,0,0,1-5.85,1.56,17.33,17.33,0,0,1-3.8,0,15.56,15.56,0,0,1-4.1-1.14,68,68,0,0,0-9.09-3.29,14.81,14.81,0,0,0-5.29-.31,33.91,33.91,0,0,0-5.52,1.36,38.27,38.27,0,0,1-5.85,1.54,10.88,10.88,0,0,1-6.29-.77c-2-.92-3.66-2.36-5.56-3.42a9.39,9.39,0,0,0-3-1.13,8.26,8.26,0,0,0-3.24.2,37.3,37.3,0,0,0-6.11,2.61,20.14,20.14,0,0,1-3.12,1.16,9.18,9.18,0,0,1-3.3.21,15.59,15.59,0,0,1-5.79-2.57,13.66,13.66,0,0,0-5.41-2.27c-3.85-.42-7.47,1.17-11,1a9.7,9.7,0,0,1-2.58-.45,14,14,0,0,1-2.29-1,39.92,39.92,0,0,0-4.08-2.18c-2.74-1.09-5.51-.75-7.83-.61a19.84,19.84,0,0,1-6.05-.21,8,8,0,0,1-3.46-1.62A4.71,4.71,0,0,1,295.78,277.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M370.79,289.15l14.12,9.77c-4.49,11.13-.34,26.58,3.56,39.22,1.51,4.92,6.52,10,6.27,15.18s4.07,13.88-.91,15.18c-3.3.87-6.89-.26-9.64-2.28a26.93,26.93,0,0,1-6.56-7.78C367.71,342.4,363.08,311.72,370.79,289.15Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M296.46,441.08a1.82,1.82,0,0,1,.54.06l1.52.28,5.58,1.06c4.71.89,11.24,2,18.48,3s13.83,1.7,18.6,2.14l5.66.5,1.54.15a1.9,1.9,0,0,1,.53.09,2.27,2.27,0,0,1-.54,0l-1.54-.05c-1.35-.06-3.28-.17-5.68-.34-4.78-.35-11.39-1-18.64-2s-13.78-2.21-18.48-3.19c-2.35-.48-4.25-.91-5.55-1.22l-1.5-.38A2.32,2.32,0,0,1,296.46,441.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.44,438.47a8.15,8.15,0,0,1,.83.18c.54.12,1.32.38,2.36.57a48.41,48.41,0,0,0,8.83,1.14,49.64,49.64,0,0,0,13.11-1.21,47.4,47.4,0,0,0,26.89-16.79,50.31,50.31,0,0,0,9.71-19.68c.27-1,.38-1.83.52-2.37a4.2,4.2,0,0,1,.2-.82,5.27,5.27,0,0,1-.1.84c-.1.55-.18,1.37-.43,2.4a46,46,0,0,1-2.71,8.53,49.35,49.35,0,0,1-6.81,11.4,48.43,48.43,0,0,1-40.4,18.07,45.36,45.36,0,0,1-8.86-1.31c-1-.23-1.81-.52-2.34-.67A3.94,3.94,0,0,1,318.44,438.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.3,262.69a3.2,3.2,0,0,1,0,.73c0,.52,0,1.2,0,2.06a29.79,29.79,0,0,0,.76,7.49,13.59,13.59,0,0,0,2.16,4.66,13.36,13.36,0,0,0,4.47,3.79,22.44,22.44,0,0,0,6.18,2.21,28.9,28.9,0,0,0,7,.68,25.82,25.82,0,0,0,13-3.67,20.52,20.52,0,0,0,7.46-8.09,18.22,18.22,0,0,0,1.94-7.22c.07-1.78-.12-2.76-.05-2.77a5.15,5.15,0,0,1,.13.71,14.48,14.48,0,0,1,.13,2.07,17.67,17.67,0,0,1-1.82,7.37,20.64,20.64,0,0,1-7.54,8.34,26,26,0,0,1-13.23,3.78,29.39,29.39,0,0,1-7.14-.7,22.82,22.82,0,0,1-6.3-2.29,13.59,13.59,0,0,1-4.59-4,13.82,13.82,0,0,1-2.17-4.82,28.46,28.46,0,0,1-.61-7.58c0-.9.08-1.6.12-2.07A3.2,3.2,0,0,1,327.3,262.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.19,264.43s-24.33.93-30.11,25.22c-6.69,28.15-2.65,59.17,5.76,74.71l.39-27.68a127.17,127.17,0,0,1,13.53-55.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.59,344.3a4.67,4.67,0,0,1-.06-.85c0-.6,0-1.41-.08-2.43s-.06-2.35,0-3.85,0-3.22.17-5.1q.09-1.43.18-3c.07-1,.2-2.09.3-3.2.19-2.22.55-4.57.89-7a149.74,149.74,0,0,1,3.46-15.9,147.18,147.18,0,0,1,5.36-15.36c1-2.3,1.92-4.49,2.93-6.48.49-1,.93-2,1.41-2.89s.95-1.79,1.4-2.62c.86-1.68,1.77-3.14,2.52-4.44s1.44-2.39,2-3.28l1.34-2a4.53,4.53,0,0,1,.5-.69,6.44,6.44,0,0,1-.41.75L313.26,268c-.56.9-1.23,2-1.95,3.32s-1.61,2.77-2.45,4.46l-1.36,2.63c-.47.92-.9,1.9-1.38,2.9-1,2-1.89,4.18-2.87,6.47a139.62,139.62,0,0,0-8.79,31.16c-.36,2.46-.74,4.8-.94,7-.11,1.11-.25,2.17-.33,3.2s-.15,2-.21,2.95c-.17,1.88-.19,3.59-.25,5.08s-.08,2.79-.08,3.85,0,1.83,0,2.43A5,5,0,0,1,292.59,344.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.72,270.59a3,3,0,0,1-.29.65c-.24.46-.54,1.07-.93,1.82-.83,1.56-1.95,3.87-3.26,6.75-.63,1.46-1.36,3-2,4.77-.33.87-.71,1.76-1,2.69s-.66,1.9-1,2.89a113.08,113.08,0,0,0-3.52,13.13,125.78,125.78,0,0,0-2.25,24.59c0,3.17.08,5.73.17,7.5,0,.85.06,1.53.07,2.05a2.78,2.78,0,0,1,0,.71,4.42,4.42,0,0,1-.09-.71c0-.51-.1-1.19-.17-2-.15-1.77-.27-4.34-.34-7.51a118.12,118.12,0,0,1,2.11-24.7A107.68,107.68,0,0,1,294.73,290c.35-1,.69-1.95,1-2.89s.73-1.82,1.07-2.69c.67-1.74,1.43-3.31,2.08-4.76,1.35-2.87,2.53-5.16,3.42-6.7l1-1.77A3.82,3.82,0,0,1,303.72,270.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.8,273.8s-16.35,44.48-4.3,82l.66,13.27s-9.22-.63-16.19-13.79-9.23-26.76-11.59-46.35,8.37-44.53,8.37-44.53S395.79,268.6,399.8,273.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.59,368a1.06,1.06,0,0,1-.24-.12l-.68-.38a13.71,13.71,0,0,1-2.34-1.86,21.93,21.93,0,0,1-5.18-9.61,55.73,55.73,0,0,1-1.6-7.41c-.47-2.69-.85-5.57-1.19-8.62a153.47,153.47,0,0,1-.86-19.9,151.12,151.12,0,0,1,1.73-19.85,120.47,120.47,0,0,1,3.4-15.91,47.81,47.81,0,0,1,4.19-10.14,29.06,29.06,0,0,1,1.59-2.53l.45-.62.17-.21s0,.09-.12.24l-.42.65c-.36.58-.88,1.43-1.5,2.57a51.22,51.22,0,0,0-4,10.14,126.9,126.9,0,0,0-3.28,15.88A157.85,157.85,0,0,0,385,320.13a160.36,160.36,0,0,0,.81,19.84c.33,3,.7,5.92,1.14,8.6A60.87,60.87,0,0,0,388.5,356a22.27,22.27,0,0,0,5,9.57A18.37,18.37,0,0,0,396.59,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,367.56a.84.84,0,0,1-.27-.09l-.78-.32a17.58,17.58,0,0,1-2.74-1.67,29.39,29.39,0,0,1-7.45-9.11,96.08,96.08,0,0,1-7.15-16,100.49,100.49,0,0,1-4.73-20.88,103.66,103.66,0,0,1-.26-21.42,99,99,0,0,1,3.16-17.21c.71-2.39,1.31-4.57,2-6.41s1.23-3.47,1.83-4.73,1-2.23,1.3-2.93c.15-.31.26-.56.35-.76a1.57,1.57,0,0,1,.14-.25.93.93,0,0,1-.09.27l-.3.78c-.29.71-.7,1.7-1.21,3s-1.09,2.9-1.75,4.76-1.27,4-1.95,6.41a100.38,100.38,0,0,0-3,17.15,104.23,104.23,0,0,0,.3,21.32A102.75,102.75,0,0,0,378,340.25a99.84,99.84,0,0,0,7,15.94,30.21,30.21,0,0,0,7.25,9.13,19.73,19.73,0,0,0,2.67,1.74l.75.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.23 290.64 398.83 293.43 397.29 297.14 387.32 295.15 388.23 290.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.47,294.19a8.58,8.58,0,0,1,1.49-1.78l.18-.19.14.22c.41.64.84,1.31,1.28,2l-.34-.09,1.18-.67c.41-.23.81-.46,1.21-.67l.22-.13.12.22,1.15,2.11-.27-.07a8.88,8.88,0,0,1,2.08-.92,8.58,8.58,0,0,1-1.89,1.27l-.17.1-.1-.18c-.4-.65-.81-1.34-1.24-2.06l.35.1-1.21.68-1.18.66-.22.12-.12-.21-1.2-2.06.32,0A9.73,9.73,0,0,1,388.47,294.19Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.39 354.19 289.86 332.9 254.75 332.9 253.64 335.01 283.36 384.42 317 386.04 301.39 354.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.24,365.93v37.21a22.64,22.64,0,0,1-8.32,17.52h0a22.62,22.62,0,0,1-22.83,3.42l-81.92-36.31,8-27.32,65.9,21.72L396,365.23Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.28 356.3 288.74 335.01 253.64 335.01 282.24 386.53 315.88 388.15 300.28 356.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.42,363.38l-5.55-6.89a19.26,19.26,0,0,0-15-7.18H308L304.71,353s-23.74,1-24.61,4l0,.94,0,.56,20.31,1.36s-17.27-.05-18.31,0-4.82-.29-4.74,1.73c.06,1.67,2,3,5,3.42,1.22.18,16.19,1.48,16.19,1.48l-16.47-.16c-1.85,0-1.62,3-.52,3.33.87.29,22,6.45,22,6.45s-3.55,2.37-6.44,2.17-7.86-3.93-8.89-2.17-.83,2.79-.21,3.2,7.44,3.93,9.72,4.55,20.85,3.56,20.85,3.56l6.7,1.08Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.55,343.32s-3.67,1.28-1.81,6a40.37,40.37,0,0,0,7.45,11.8,4.31,4.31,0,0,0,1.47,4.22s-2.6.65-1,5a4.94,4.94,0,0,0,3.09,6.5s-1.3,3.74,3.41,5.52,9.26-1.3,9.26-1.3Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,360.75c3.34.9,7,1.62,10.09,2.79,1,.38,2,.4,2.7,1.25a2.33,2.33,0,0,1,.06,3,3.25,3.25,0,0,1-2.72.55,48,48,0,0,1-10.34-2.87",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.33,366.32c3.33.9,7,1.61,10.08,2.79,1,.38,2,.4,2.7,1.25a2.33,2.33,0,0,1,.06,3,3.29,3.29,0,0,1-2.72.55A48.57,48.57,0,0,1,267.11,371",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.22,372.05c3.34.9,7,1.61,10.09,2.78,1,.39,2,.41,2.69,1.26a2.32,2.32,0,0,1,.06,3,3.22,3.22,0,0,1-2.71.54A48,48,0,0,1,269,376.75",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,365.57c0-.14,2.41.68,5.37,1.5s5.39,1.35,5.37,1.49a19.75,19.75,0,0,1-5.51-1A20.59,20.59,0,0,1,266,365.57Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.36,370.48a61.43,61.43,0,0,1,6.1,1.74c3.36,1,6.11,1.69,6.08,1.83a43.67,43.67,0,0,1-12.18-3.57Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.55,376.8a33,33,0,0,1,5.73,1.16,34.11,34.11,0,0,1,5.61,1.67,32.85,32.85,0,0,1-5.73-1.16A32.28,32.28,0,0,1,267.55,376.8Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.22,360.07c0-.15,3,.85,6.73,1.81s6.78,1.52,6.76,1.68a8.19,8.19,0,0,1-2-.17,48.32,48.32,0,0,1-4.84-1,46,46,0,0,1-4.73-1.47A7.68,7.68,0,0,1,263.22,360.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.63,353.32A67.35,67.35,0,0,1,305,353a67.19,67.19,0,0,1,8.33.21,66.08,66.08,0,0,1-8.33.31A65.93,65.93,0,0,1,296.63,353.32Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.46,344a1.76,1.76,0,1,0-.27-2.48A1.76,1.76,0,0,0,271.46,344Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.8,381.21a2.08,2.08,0,0,1,.81.09,15.85,15.85,0,0,1,2.15.54,24.67,24.67,0,0,1,11.87,8.24,16.8,16.8,0,0,1,1.26,1.82c.27.45.4.7.37.72s-.71-.91-1.92-2.31a28.24,28.24,0,0,0-11.7-8.12C392.9,381.55,391.78,381.29,391.8,381.21Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.11,282.64h0a20.05,20.05,0,0,1-18.43-21c.37-7.6.77-14.45.77-14.45s-16.3-2.54-16.5-18.82,2.63-53.7,2.63-53.7h0a56.61,56.61,0,0,1,56.88,7.16l2.41,1.85-6.17,80.49A20.06,20.06,0,0,1,347.11,282.64Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.42,247a37.86,37.86,0,0,0,21.23-6s-5,11.72-21.27,10.25Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.6,200.21a2.32,2.32,0,0,0,2.24,2.35,2.23,2.23,0,0,0,2.4-2.1,2.34,2.34,0,0,0-2.24-2.35A2.23,2.23,0,0,0,319.6,200.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.66,197.6c.29.3,2-1,4.55-1s4.34,1.26,4.61,1c.13-.14-.16-.69-1-1.27a6.44,6.44,0,0,0-3.69-1.14,6.16,6.16,0,0,0-3.62,1.17C318.78,196.91,318.52,197.46,318.66,197.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.2,200.8a2.33,2.33,0,0,0,2.24,2.35,2.22,2.22,0,0,0,2.4-2.1,2.33,2.33,0,0,0-2.24-2.35A2.22,2.22,0,0,0,343.2,200.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.26,198.07c.29.3,2.06-1,4.56-1s4.33,1.26,4.61,1c.13-.13-.16-.68-1-1.26a6.36,6.36,0,0,0-3.69-1.14,6.15,6.15,0,0,0-3.63,1.17C343.38,197.38,343.12,197.93,343.26,198.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.18,216.63c0-.14-1.55-.41-4.07-.73-.64-.07-1.24-.2-1.35-.63a3.26,3.26,0,0,1,.43-1.9l1.89-4.87c2.62-6.93,4.52-12.62,4.24-12.73s-2.63,5.43-5.26,12.36q-.94,2.56-1.81,4.9a3.75,3.75,0,0,0-.33,2.51,1.58,1.58,0,0,0,1.05.93,4.17,4.17,0,0,0,1.09.15C332.6,216.76,334.17,216.77,334.18,216.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.55,218.36c-.41,0-.42,2.69-2.74,4.62s-5.22,1.63-5.24,2c0,.17.64.53,1.87.56a6.75,6.75,0,0,0,4.37-1.52,5.86,5.86,0,0,0,2.12-3.88C342,219,341.73,218.34,341.55,218.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.62,188.26c.24.68,2.74.35,5.68.71s5.31,1.15,5.7.54c.17-.29-.24-.93-1.2-1.59a9.48,9.48,0,0,0-4.22-1.48,9.65,9.65,0,0,0-4.45.52C343.05,187.4,342.51,187.93,342.62,188.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.58,190.35c.44.57,2.16,0,4.24,0s3.83.39,4.23-.21c.18-.29-.1-.86-.87-1.39a6.09,6.09,0,0,0-6.82.21C319.63,189.49,319.38,190.08,319.58,190.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.87,200.56c.27-.12,11.19-3.31,10.83,7.83s-11.46,8.48-11.47,8.16S372.87,200.56,372.87,200.56Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.77,212.44c.05,0,.19.14.51.3a1.91,1.91,0,0,0,1.45.08c1.19-.39,2.24-2.23,2.36-4.23a6.33,6.33,0,0,0-.46-2.8,2.24,2.24,0,0,0-1.41-1.54,1,1,0,0,0-1.16.5c-.16.31-.1.53-.16.55s-.23-.2-.13-.65a1.32,1.32,0,0,1,.47-.69,1.49,1.49,0,0,1,1.08-.25,2.76,2.76,0,0,1,2,1.8,6.57,6.57,0,0,1,.57,3.12c-.14,2.24-1.36,4.31-3,4.72a2.1,2.1,0,0,1-1.77-.35C375.78,212.71,375.73,212.46,375.77,212.44Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.34,160.61a17.23,17.23,0,0,1,26.75-5.14,16.86,16.86,0,0,1,27.71-3.6c3.12,3.54,4.74,8.35,8.4,11.33,3.16,2.57,7.46,3.43,10.64,6a12.3,12.3,0,0,1-4.39,21.44c3.5,6.3.22,15.33-6.5,17.93l-1.62-.67A23.18,23.18,0,0,1,367,182.31a5.83,5.83,0,0,1-.59,0,13,13,0,0,1-16.94-3.87,14.46,14.46,0,0,1-15.52.65,6,6,0,0,0-2.34-1.06,5.58,5.58,0,0,0-2.92.87,13.7,13.7,0,0,1-7.88,1.59,7.59,7.59,0,0,1-5.92-4.23,1.25,1.25,0,0,1-.19,0,8.75,8.75,0,0,1-6.52-6.31A13.07,13.07,0,0,1,309.34,160.61Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsMobile);
export default __webpack_public_path__ + "static/media/gps-mobile.7c79962884bd0fca93a04023096dd54a.svg";
export { ForwardRef as ReactComponent };